














import { EventType } from '@/constants';
import Vue from 'vue'
export default Vue.extend({
  name: 'ImpersonationHeader',
  data () {
    return {
      EventType
    }
  },
  props: {
    jobId: {
      type: String,
      required: true
    },
    homeBuyerName: {
      type: String,
      required: true
    }
  }
})
